import { render, staticRenderFns } from "./PersonalMatchMaking.vue?vue&type=template&id=123854fa&scoped=true&"
import script from "./PersonalMatchMaking.vue?vue&type=script&lang=js&"
export * from "./PersonalMatchMaking.vue?vue&type=script&lang=js&"
import style0 from "./PersonalMatchMaking.vue?vue&type=style&index=0&id=123854fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123854fa",
  null
  
)

export default component.exports